import React, { useEffect } from "react";
import PropTypes from "prop-types";
/* components */
import WidgetWrap from "./components/wrap";
import WidgetHead from "./components/head";
import { useDispatch, useSelector } from "react-redux";
import { getWidgetData } from "@modules/dashboard";
import { IconRefresh } from "@mzc-cloudplex/icons";

const ZendeskNotice = ({
    id,
    name,
    title,
    icon,
    color,
    widgets,
    onMove,
    onDelete,
    fullWidth,
    logo,
    viewAllUrl,
    params,
    type,
}) => {
    const dispatch = useDispatch();

    const { widgetData } = useSelector(({ dashboard }) => ({
        widgetData: dashboard.dashboardWidgetData?.find((widget) => widget.id === id),
    }));

    useEffect(() => {
        dispatch(getWidgetData({ id, params }));
    }, []);

    //draggable같이 알아듣기 쉬운 속성으로 wrap에 넘겨주기
    return (
        <WidgetWrap id={name} onMove={onMove} fullWidth={fullWidth} blockDrag={fullWidth} type={type}>
            <WidgetHead
                title={title}
                icon={icon}
                name={name}
                color={color}
                widgets={widgets}
                onDelete={onDelete}
                externalLink={viewAllUrl}
            />
            <div className={"body"}>
                <div className={"inner"}>
                    <div className="control">
                        <div className="control-tools">
                            <button
                                className="btn btn-icon-solid"
                                onClick={() => dispatch(getWidgetData({ id, params }))}
                            >
                                <IconRefresh size={16} />
                            </button>
                        </div>
                    </div>
                    <div className={`widget-notice d-flex`}>
                        {logo && (
                            <div className={`logo`}>
                                <img src={logo} alt="logo" width={128} height={128} />
                            </div>
                        )}
                        <div className={`list-notice`}>
                            {widgetData && widgetData.pending && (
                                <span className={"loading"}>
                                    <i className={"loading-content"} />
                                </span>
                            )}
                            <ul>
                                {widgetData &&
                                    widgetData.data?.map((text, index) => (
                                        <li key={`${id}-${index}`}>
                                            <a href={text.html_url} target="_blank">
                                                <span className={`text-default`}>{text.title}</span>
                                                <span className={`text-secondary`}>
                                                    {text.updated_at
                                                        ? new Date(text.updated_at)?.toISOString()?.split("T")?.[0]
                                                        : ""}
                                                </span>
                                            </a>
                                        </li>
                                    ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </WidgetWrap>
    );
};

ZendeskNotice.propTypes = {
    user: PropTypes.object,
    name: PropTypes.string,
    title: PropTypes.string,
    icon: PropTypes.node,
    widgets: PropTypes.array,
    onMove: PropTypes.func,
    onDelete: PropTypes.func,
};

export default ZendeskNotice;
